export default {"src":"/_next/static/media/milk.057e7bb0.svg","height":24,"width":12,"blurWidth":0,"blurHeight":0};